import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import logo from "src/Assets/images/LandingPageImages/logo.png";
import skopiclogo from "src/Assets/images/LandingPageImages/skopic_logo1.png";
// import office from "src/Assets/images/LandingPageImages/Office.svg";
// import Neighborhood from "src/Assets/images/LandingPageImages/Neighborhood.svg";
// import classroom from "src/Assets/images/LandingPageImages/Classroom.svg";
// import cityhall from "src/Assets/images/LandingPageImages/CityHall.svg";
import office from "src/Assets/images/S1Office.png";
import Neighborhood from "src/Assets/images/S1Neighborhood.png";
import classroom from "src/Assets/images/S1Classroom.png";
import cityhall from "src/Assets/images/S1Cityhall.png";
import globe from "src/Assets/images/LandingPageImages/Globe.svg";
import verified from "src/Assets/images/LandingPageImages/Verfied.svg";
import paper from "src/Assets/images/LandingPageImages/Paper.svg";
import group from "src/Assets/images/LandingPageImages/group.svg";
import single from "src/Assets/images/LandingPageImages/single.svg";
import demoImge from "src/Assets/images/LandingPageImages/demo.png";
import AppStore from "src/Assets/images/LandingPageImages/AppStore.svg";
import PlayStore from "src/Assets/images/LandingPageImages/play.svg";
import facebook from "src/Assets/images/LandingPageImages/Facebook.svg";
import twitter from "src/Assets/images/LandingPageImages/Twitter.svg";
// import Switch from "./components/Switch";
import TabSwitch from "./components/TabSwitch";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import FooterComponent from "../../Modules/Reusuablecomponents/FooterComponent";
import "src/Assets/css/LandingPage/LandingPage.css";
import { useSelector, useDispatch } from "react-redux";
import { extractCommunityInfo } from "src/Utils/extractCommunityInfo";
import { isMobile, isInAppBrowser, isAndroid, isIOS, isDesktop } from "src/Utils/deviceDetection";
import API from "../../network";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction.js";
import { clearEmailAction } from "src/store/actions/emailTemplatesActions/emailTempActions";
import EmailActionExecutor from "./components/EmailActionExecutor/EmailActionExecutor";
import MobileInviteLandingPage from "./components/MobileInviteLandingPage/MobileInviteLandingPage";
import MobileAppBanner from "./components/MobileAppBanner/MobileAppBanner";
import EmailMismatchModal from "./components/EmailMismatchModal/EmailMismatchModal";
import { SignupContext } from "src/context/SignupContext/SignupContext";

function LandingPage() {
  const dispatch = useDispatch();
  const [userSelectedBrowser, setUserSelectedBrowser] = useState(false);
  const [showTopBanner, setShowTopBanner] = useState(false);
  const [dismissInAppNotice, setDismissInAppNotice] = useState(false);
  const [showMismatchModal, setShowMismatchModal] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (signInStatus === "true") {
      dispatch(SignInActions.authUser());
    }
  }, []);

  const signInStatus = Cookies.get("signInStatus");
  const signupContext = useContext(SignupContext);
  const authenticationVerificationStatus = useSelector(
    (state) => state.SignInReducer.isAuthorized,
  );
  const [emailStatus, setEmailStatus] = useState(null);

  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const emailAction = useSelector((state) => state.emailActionReducer);
  const { invitedCommunityName, invitedCommunityId, invitedEmailId } =
    extractCommunityInfo(emailAction);

  // TRUE only when user comes from email invite
  const isInviteFlow =
    invitedEmailId &&
    invitedEmailId !== "undefined" &&
    invitedEmailId !== "null";

  // Check email match/mismatch for logged-in user on invitation flow
  useEffect(() => {
    if (
      isInviteFlow &&
      invitedEmailId &&
      (signInStatus === "true" || authenticationVerificationStatus)
    ) {
      const currentEmail =
        userDetails?.email ||
        userDetails?.emailId ||
        userDetails?.userEmail ||
        userDetails?.userData?.emailId ||
        Cookies.get("userEmail");

      if (
        currentEmail &&
        currentEmail.toLowerCase().trim() !== invitedEmailId.toLowerCase().trim()
      ) {
        setShowMismatchModal(true);
      } else if (
        currentEmail &&
        currentEmail.toLowerCase().trim() === invitedEmailId.toLowerCase().trim()
      ) {
        setShowMismatchModal(false);
        if (invitedCommunityId && invitedCommunityName) {
          const autoFollowAndLand = async () => {
            try {
              const formdata = new FormData();
              formdata.append("communityID", invitedCommunityId);
              formdata.append("communityName", invitedCommunityName);
              formdata.append("followStat", 1);
              formdata.append("sourceApp", "WebApp");
              await API.followUnfollowCommunity(formdata);
            } catch (err) {
              console.error("Error auto-following community on invite:", err);
            } finally {
              dispatch(clearEmailAction());
            }
          };
          autoFollowAndLand();
        }
      }
    }
  }, [
    isInviteFlow,
    invitedEmailId,
    invitedCommunityId,
    invitedCommunityName,
    signInStatus,
    authenticationVerificationStatus,
    userDetails,
    dispatch,
  ]);

  const handleSignOutFromMismatchModal = () => {
    setShowMismatchModal(false);
    Cookies.remove("signInStatus");
    localStorage.setItem('logout-event', Date.now().toString());
    Cookies.remove("userEmail");
    dispatch(SignInActions.signOut());
  };

  const handleCancelMismatchModal = () => {
    setShowMismatchModal(false);
  };

const getUserEmailInfo = async () => {
  // NEW: Use OTP email when the action is OTP,
  // otherwise use the invite email.
  const emailToCheck =
    emailAction?.action === "otp" ? emailAction?.emailId : invitedEmailId;

  if (!emailToCheck) return;

  try {
    const formData = new FormData();
    formData.append("mail", emailToCheck);

    const response = await API.verifyEmail(formData);
    setEmailStatus(response?.data?.status);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

useEffect(() => {
  if (isInviteFlow || emailAction?.action === "otp") {
    getUserEmailInfo();
  }
}, [isInviteFlow, emailAction?.action, emailAction?.emailId]);

  useEffect(() => {
    if (authenticationVerificationStatus === true) {
      signupContext?.resetSignupState();
    }
  }, [authenticationVerificationStatus]);

  const loggedInEmail =
    userDetails?.email ||
    userDetails?.emailId ||
    userDetails?.userEmail ||
    userDetails?.userData?.emailId ||
    Cookies.get("userEmail");

  const isEmailMismatch =
    isInviteFlow &&
    invitedEmailId &&
    loggedInEmail &&
    loggedInEmail.toLowerCase().trim() !== invitedEmailId.toLowerCase().trim();

  if (
    signInStatus === "true" &&
    authenticationVerificationStatus === true &&
    !isEmailMismatch
  ) {
    return <Redirect to="/Home" />;
  }

  const isMobileOS = isAndroid() || isIOS();
  const isMobileUser = isMobile();

  // Trigger mobile modal prompt only if user is on Android or iOS and hasn't dismissed/clicked Cancel
  const showMobileOverlay = isMobileOS && isInviteFlow && !userSelectedBrowser;

  const handleCancelMobilePrompt = () => {
    setUserSelectedBrowser(true);
    setShowTopBanner(true);
  };

  return (
    <>
      <EmailActionExecutor />
      {isMobileUser && isInAppBrowser() && !dismissInAppNotice && (
        <div
          style={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            padding: "10px 16px",
            fontSize: "13px",
            textAlign: "center",
            borderBottom: "1px solid #ffeeba",
            position: "sticky",
            top: 0,
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>
            💡 Viewing inside email app. For best experience, tap <strong>{"\u2022\u2022\u2022"}</strong> or <strong>Share</strong> icon and select <strong>Open in Safari</strong>.
          </span>
          <button
            type="button"
            onClick={() => setDismissInAppNotice(true)}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "18px",
              fontWeight: "bold",
              color: "#856404",
              cursor: "pointer",
              marginLeft: "10px",
              lineHeight: 1,
            }}
          >
            {"\u00D7"}
          </button>
        </div>
      )}
      {isMobileUser && showTopBanner && (
        <MobileAppBanner
          communityName={invitedCommunityName}
          emailActionData={emailAction}
          onClose={() => setShowTopBanner(false)}
        />
      )}
      {showMobileOverlay && (
        <MobileInviteLandingPage
          communityName={invitedCommunityName}
          emailActionData={emailAction}
          onOpenInBrowser={handleCancelMobilePrompt}
        />
      )}
      <EmailMismatchModal
        show={showMismatchModal}
        loggedInEmail={loggedInEmail}
        invitedEmail={invitedEmailId}
        onSignOut={handleSignOutFromMismatchModal}
        onCancel={handleCancelMismatchModal}
      />
      <main className="Landingpage">
        <div className="Navbar">
          <div className="Logo">
            <img
              src={logo}
              alt="Skopic-Logo"
              width={90}
              height={28}
              style={{ width: "165px", height: "100px" }}
            />
          </div>
        </div>
        <div className="container" style={{ marginTop: -40 }}>
          <div className="row align-items-start">
            <div className="col-md-5">
              <TabSwitch emailStatus={emailStatus} isInviteFlow={isInviteFlow}>
                <div label="Sign In">
                  <SignIn />
                </div>
                <div label="Join Now">
                  <SignUp emailStatus={emailStatus} />
                </div>
              </TabSwitch>
            </div>
            <div className="col-md-7 abountSkopic">
              <div className="content">
                <h1 className="mainHeading">
                  Share and connect with your Community matters.
                </h1>
                <p className="mainText">
                  Skopic's information-networking platform builds stronger and
                  thriving local Communities globally by letting people engage,
                  learn and get organized on real matters related to everyday
                  living.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="imageContent">
          <div className="image">
            <img src={office} alt="officeImage" />
          </div>
          <div className="image">
            <img src={Neighborhood} alt="NeighborhoodImage" />
          </div>
          <div className="image">
            <img src={classroom} alt="ClassroomImage" />
          </div>
          <div className="image">
            <img src={cityhall} alt="CityHallImage" />
          </div>
        </div>
        <div className="information pt-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-4">
                <div className="info-content">
                  <div className="info-img">
                    <img src={globe} alt="Globe" />
                  </div>
                  <p style={{ fontSize: "24px" }}>
                    Information network that is geographically and socially
                    relevant
                  </p>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="info-content">
                  <div className="info-img">
                    <img src={verified} alt="Globe" />
                  </div>
                  <p style={{ fontSize: "24px" }}>
                    Credible and moderated content
                  </p>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="info-content">
                  <div className="info-img">
                    <img src={paper} alt="Globe" />
                  </div>
                  <p style={{ fontSize: "24px" }}>
                    Clutter-free content with microblogging
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container pt-md-5">
          <div className="row pt-5 align-items-center">
            <div className="col-md-6">
              <div className="contentImage">
                <img src={group} alt="ContentImage" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="contentInfo">
                <ul className="contentList">
                  <li className="contentListItems">
                    Communicate, collaborate and stay connected in real-time
                    with your Community
                  </li>
                  <li className="contentListItems">
                    Share knowledge to benefit your peers in the Community
                  </li>
                  <li className="contentListItems">
                    Find answers instantly receive answers from credible
                    peers{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-md-5">
          <div className="row py-5 align-items-center">
            <div className="col-md-6 order-md-1">
              <div className="contentImage">
                <img src={single} alt="ContentImage" />
              </div>
            </div>
            <div className="col-md-6 order-md-0">
              <div className="contentInfo">
                <ul className="contentList">
                  <li className="contentListItems">
                    Connect with actionable information instantly
                  </li>
                  <li className="contentListItems">
                    Organize and share conversations regarding Community
                    activities, topics and important matters{" "}
                  </li>
                  <li className="contentListItems">
                    Create and manage your group, club or classroom within
                    Community{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="container">
            <div className="skopicInfo">
              <div className="row justify-content-center">
                <div className="col-md-9">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <img src={skopiclogo} alt="skopiclogo" />
                      <div className="SocailSignIn">
                        <div className="QuickDemo">
                          <a
                            href="https://www.youtube.com/watch?v=eKLNO4nDXkc"
                            target="_blank"
                          >
                            <img
                              src={demoImge}
                              alt="demo"
                              className="demoImge"
                            />
                          </a>
                          <br />
                          <p style={{ fontSize: 18, color: "#7A7A7A" }}>
                            Quick Demo
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p style={{ color: "#373334", textDecoration: "none" }}>
                        Be a contributor, be a moderator,
                        <br />
                        be important in your Community.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footersLinks">
              <div className="mobileLinks pt-5 pb-3">
                <a
                  href="https://apps.apple.com/in/app/skopic/id1551465962"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <img src={AppStore} alt="AppStore" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.inspira.skopic"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <img src={PlayStore} alt="PlayStore" />
                </a>
              </div>
              {/* <div className="socialLinks pt-3">
                <a href="https://www.facebook.com/skopic.inc" target="_blank" rel="noreferrer">
                  {" "}
                  <img src={facebook} alt="facebook" />
                </a>
                <a href="https://twitter.com/SkopicInc" target="_blank" rel="noreferrer">
                  {" "}
                  <img src={twitter} alt="twitter" />
                </a>
              </div> */}
              <div className="appLinks">
                <FooterComponent />
              </div>
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: "2%",
                color: "#000000",
              }}
            >
              Skopic &#169; {new Date().getFullYear()}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default LandingPage;
